import { FeatureWrap, LanguagePicker, List, Modal, ModalTabs, PDFRenderer, Show } from "components";
import { classNames, wrapClick } from "utils";

import { LocationGenerics } from "router/location";
import SupportingDocument from "./components/supporting-document";
import _ from "lodash";
import config from "config";
import { useFormik } from "formik";
import { useOfferSupportingDocuments } from "hooks/data/use-supporting-documents";
import { useSearch } from "react-location";
import { useState } from "react";

const externalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "PlaceIT Offer Slip",
    href: "PLACE_IT_PLACING_SLIP",
  },
  {
    name: "Supporting Documents",
    href: "SUPPORTING_DOCUMENTS",
  },
];
const internalTabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "Supporting Documents",
    href: "INTERNAL_SUPPORTING_DOCUMENTS",
  },
];

export default function ViewOfferSlipContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("PLACING_SLIP");
  const searchParams = useSearch<LocationGenerics>();
  const [id, type, place_it_id] = searchParams?.id?.split(":") || [];
  const { documents, loading } = useOfferSupportingDocuments({ offerId: id || "" });
  const form = useFormik({
    initialValues: {
      lang: "en",
    },
    onSubmit(values, formikHelpers) { },
  });


  const urls = {
    PLACING_SLIP: `${config.asset.uri}generate_placing_slip/${btoa(
      JSON.stringify({
        offer_id: id,
        lang: form.values.lang,
      })
    )}`,
    PLACE_IT_PLACING_SLIP: `${config.asset.placeItUri}/generate-broker-placing-slip/${place_it_id}`,
    SUPPORTING_DOCUMENTS: `${config.asset.placeItUri}/generate-broker-supporting-docs/${place_it_id}`,
    INTERNAL_SUPPORTING_DOCUMENTS: `${config.asset.uri}generate-broker-supporting-docs/${id}`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      size="6xl"
      title="Placing Slip"
      description="Details of placing slip are shown below"
      // hideActions
      hidePadding
    >
      <ModalTabs tabs={type === "PLACEIT" ? externalTabs : internalTabs} setOrderStatus={setOrderStatus} orderStatus={orderStatus} />

      <div className="space-y-4">
        <Show if={documents.length > 0 && orderStatus === "INTERNAL_SUPPORTING_DOCUMENTS"}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
            <List
              data={documents}
              renderItem={(doc) => (
                <SupportingDocument
                  key={doc}
                  documentName={doc}
                  offerId={id || ""}
                />
              )}
            />
          </div>
        </Show>

        <div className="bg-white rounded-2xl shadow">
          <PDFRenderer reloadToken={loading ? "" : String(Date.now())} url={_.get(urls, orderStatus)} />
        </div>
      </div>

    </Modal>
  );
}


